export const LeftBlock = [
  {
    label: 'FAQS',
    link: 'https://www.aldar.com/en/faqslisting',
  },
  {
    label: 'ABU DHABI',
    link: 'https://www.aldar.com/en/about-abu-dhabi',
  },
  {
    label: 'DARNA LOYALTY PROGRAM',
    link: 'https://darnarewards.com/',
  },
  {
    label: 'CONTACT US',
    link: 'https://www.aldar.com/en/contact-us',
  },
  {
    label: 'WHISTLEBLOWER SYSTEM ',
    link: 'https://secure.ethicspoint.eu/domain/media/en/gui/103052/index.html',
  },
];

export const EXPLORE_ABU_DHABI = {
  mainHeading: 'EXPLORE ABU DHABI',
  link: 'https://www.aldar.com/en/about-abu-dhabi',
  subLinks: [
    {
      label: 'Market Overview',
      link: 'https://www.aldar.com/en/about-abu-dhabi/market-overview',
    },
    {
      label: 'Golden Visa',
      link: 'https://www.aldar.com/en/about-abu-dhabi/golden-visa',
    },
    {
      label: 'Dari',
      link: 'https://www.aldar.com/en/about-abu-dhabi/dari',
    },
  ],
};

export const MEDIA = {
  mainHeading: 'MEDIA',
  subLinks: [
    {
      label: 'News',
      link: 'https://www.aldar.com/en/news-and-media',
    },
    {
      label: 'Gallery',
      link: 'https://www.aldar.com/en/media/gallery',
    },
    {
      label: 'Blog',
      link: 'https://www.aldar.com/en/blog',
    },
  ],
};

export const INVESTORS_RELATIONS = {
  mainHeading: 'INVESTORS RELATIONS',
  link: 'https://www.aldar.com/en/investors',
  subLinks: [
    {
      label: 'Reports & Presentations',
      link: 'https://www.aldar.com/en/investors/reports',
    },
    {
      label: 'Shareholder Center',
      link: 'https://www.aldar.com/en/investors/shareholders',
    },
    {
      label: 'Debt Investors',
      link: 'https://www.aldar.com/en/investors/debt',
    },
    {
      label: 'Analyst Coverage',
      link: 'https://www.aldar.com/en/investors/coverage',
    },
    {
      label: 'Financial Calendar',
      link: 'https://www.aldar.com/en/investors/financial-calendar',
    },
    {
      label: 'Company Announcements',
      link: 'https://www.aldar.com/en/investors/company-announcements',
    },
    {
      label: 'Contact Us',
      link: 'https://www.aldar.com/en/investors/contact-us',
    },
  ],
};

export const CAREERS = {
  mainHeading: 'CAREERS',
  subLinks: [
    {
      label: 'Work with us',
      link: 'https://fa-ewnp-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1',
      icon: '',
    },
    {
      label: 'Graduate program',
      link: 'https://www.aldar.com/en/graduate-programme',
      icon: true,
    },
  ],
};

export const EXPLORE_ALDAR = {
  mainHeading: 'EXPLORE ALDAR',
  link: 'https://www.aldar.com/en/about-us/landing',
  subHeading: 'About Aldar',
  subLinks: [
    {
      label: 'Story',
      link: 'https://www.aldar.com/en/about-us/story',
    },
    {
      label: 'Operating Model',
      link: 'https://www.aldar.com/en/about-us/operating-model',
    },
    {
      label: 'Leadership',
      link: 'https://www.aldar.com/en/about-us/leadership',
    },
    {
      label: 'Culture and Values',
      link: 'https://www.aldar.com/en/about-us/culture-and-values',
    },
    {
      label: 'Strategy',
      link: 'https://www.aldar.com/en/about-us/strategy',
    },
    {
      label: 'Sponsorships',
      link: 'https://www.aldar.com/en/about-us/sponsorships',
    },
    {
      label: 'Procurement',
      link: 'https://www.aldar.com/en/procurement',
    },
    {
      label: 'Aldar Square',
      link: 'https://www.aldar.com/en/about-us/aldar-square',
    },
  ],
};

export const E_SERVICES = {
  mainHeading: 'E-Services',
  subLinks: [
    // {
    //   label: 'Customer Portal',
    //   link: 'https://customer.aldar.com/?_gl=1*1grqiag*_gcl_au*OTkzNTY4NjE1LjE2OTk1MjEwMTY.',
    //   icon: true,
    // },
    {
      label: 'Khidmah',
      link: 'https://www.khidmah.com/en',
      icon: true,
    },
    {
      label: 'Aldar Brokers',
      link: 'https://broker.aldar.com/_layouts/15/brokerportal/BrokerLogin.aspx?ReturnUrl=%2f_layouts%2f15%2fAuthenticate.aspx%3fSource%3d%252F&Source=%2F&_gl=1*1grqiag*_gcl_au*OTkzNTY4NjE1LjE2OTk1MjEwMTY.',
      icon: true,
    },
    {
      label: 'Aldar Apps',
      link: 'https://play.google.com/store/apps/details?id=com.aldar.mobileapp&hl=en&gl=US',
      icon: true,
    },
  ],
};

export const BUSINESS_DEVELOPMENT = {
  mainHeading: 'Business - Development',
  subLinks: [
    {
      label: 'Residential',
      link: 'https://www.aldar.com/en/portfolio/residential',
    },
    {
      label: 'Land Portfolio',
      link: 'https://www.aldar.com/en/portfolio/land',
    },
    {
      label: 'Partnerships',
      link: 'https://www.aldar.com/en/explore-aldar/businesses/development/partnerships',
    },
  ],
};

export const BUSINESS_INVESTMENT = {
  mainHeading: 'Business - Investment',
  subLinks: [
    {
      label: 'Commercial',
      link: 'https://www.aldar.com/en/portfolio/commercial',
    },
    {
      label: 'Retail',
      link: 'https://www.aldar.com/en/portfolio/retail',
    },
  ],
};

export const EDUCATION = {
  mainHeading: 'Education',
  link: 'https://www.aldar.com/en/portfolio/education',
  subLinks: [],
};

export const HOSPITALITY = {
  mainHeading: 'Hospitality',
  link: 'https://www.aldar.com/en/portfolio/hospitality',
  subLinks: [],
};

export const PROJECTS = {
  mainHeading: 'Projects',
  link: 'https://www.aldar.com/en/portfolio/aldar-projects',
  subLinks: [],
};

export const CORPORATE_GOVERNANCE = {
  mainHeading: 'Corporate Governance',
  link: 'https://www.aldar.com/en/investors/corporate-governance',
  subLinks: [],
};

export const SUSTAINABILITY = {
  mainHeading: 'Sustainability',
  link: 'https://www.aldar.com/en/sustainability',
  subLinks: [
    {
      label: 'Sustainability Strategy',
      link: 'https://www.aldar.com/en/sustainability/strategy',
    },
    {
      label: 'Governance & Policies',
      link: 'https://www.aldar.com/en/sustainability/governance-and-policies',
    },
    {
      label: 'Reporting & Performance',
      link: 'https://www.aldar.com/en/sustainability/reporting',
    },
    {
      label: 'Net Zero',
      link: 'https://www.aldar.com/en/sustainability/netzero',
    },
    {
      label: 'Community Outreach',
      link: 'https://www.aldar.com/en/explore-aldar/sustainability/corporate-social-responsibility',
    },
  ],
};

export const ALDAR_BRAND = {
  mainHeading: 'Aldar Brand',
  link: 'https://www.aldar.com/en/aldar-brand',
  subLinks: [],
};

export const LIVE_ALDAR = {
  mainHeading: 'Live Aldar',
  link: 'https://www.aldar.com/en/live-aldar',
  subLinks: [
    {
      label: 'Year of Sustainability',
      link: 'https://www.aldar.com/en/live-aldar/year-of-sustainability',
      icon: '',
    },
    {
      label: `Emirati Women's Day`,
      link: 'https://www.aldar.com/en/live-aldar/emirati-womens-day',
      icon: '',
    },
    {
      label: 'In Focus',
      link: 'https://www.aldar.com/en/live-aldar/in-focus',
      icon: '',
    },
    {
      label: 'Ahal Aldar',
      link: 'https://www.aldar.com/en/live-aldar/ahal-aldar',
      icon: '',
    },
    {
      label: 'Aldar Stories',
      link: 'https://www.aldar.com/en/live-aldar/aldar-stories',
      icon: '',
    },
  ],
};

export const ART = {
  mainHeading: 'Art',
  link: 'https://www.aldar.com/en/about-us/art',
  subLinks: [],
};

export const INNOVATION = {
  mainHeading: 'Innovation',
  link: 'https://www.aldar.com/en/about-us/innovation',
  subLinks: [
    {
      label: 'Manassah',
      link: 'https://www.aldar.com/en/about-us/innovation/manassah3',
    },
    {
      label: 'Scale Up By Aldar',
      link: 'https://www.aldar.com/en/about-us/innovation/scale-up',
    },
  ],
};
